// @flow

import type { Action } from "redux-action";
import { beginRequest, completeRequest } from "@store/utils";

import type { ApprovableContainer } from "@modules/service/types";
import type { AbsenceMonitoringState, AbsenceMonitoring } from "./types";

const startRequest = beginRequest(["requestsInProgress"]);

const finishRequest = completeRequest(["requestsInProgress"]);

// Get  List

export const onUpdateAbsenceMonitoring = (state: AbsenceMonitoringState) => () =>
  startRequest(state);
export const onUpdateAbsenceMonitoringSuccess = (state: AbsenceMonitoringState) => () =>
  finishRequest(state);
export const onUpdateAbsenceMonitoringError = (state: AbsenceMonitoringState) => () =>
  finishRequest(state);

export const onGetAbsenceMonitoringList = (state: AbsenceMonitoringState) => () =>
  startRequest(state);

export const onGetAbsenceMonitoringListSuccess = (state: AbsenceMonitoringState) => ({
  payload,
}: Object) => ({
  ...state,
  ...finishRequest(state),
  error: null,
  list: payload,
});

export const onGetAbsenceMonitoringListError = (state: AbsenceMonitoringState) => ({
  payload,
}: Object) => ({
  ...state,
  ...finishRequest(state),
  success: false,
  error: payload,
});

// Get Record

export const onGet = (state: AbsenceMonitoringState) => () => startRequest(state);

export const onGetSuccess = (state: AbsenceMonitoringState) => ({ payload }: Object) => ({
  ...state,
  ...finishRequest(state),
  error: null,
  current: payload,
});

export const onGetError = (state: AbsenceMonitoringState) => ({ payload }: Object) => ({
  ...state,
  ...finishRequest(state),
  success: false,
  error: payload,
});

// Get Schema

export const onGetSchema = (state: AbsenceMonitoringState) => () => startRequest(state);

export const onGetSchemaSuccess = (state: AbsenceMonitoringState) => ({ payload }: Object) => ({
  ...state,
  ...finishRequest(state),
  error: null,
  schema: payload,
});

export const onGetSchemaError = (state: AbsenceMonitoringState) => ({ payload }: Object) => ({
  ...state,
  ...finishRequest(state),
  success: false,
  error: payload,
});

// Create

export const onNew = (state: AbsenceMonitoringState) => (action: Action<void>) => ({
  ...state,
  draft: {},
});

export const onStartDraftSuccess = (state: AbsenceMonitoringState) => (
  action: Action<ApprovableContainer<AbsenceMonitoring>>,
) => ({
  ...state,
  draft: (action.payload && action.payload.active) || {},
});

export const onDuplicateSuccess = (state: AbsenceMonitoringState) => (
  action: Action<AbsenceMonitoring>,
) => ({
  ...state,
  draft: action.payload,
});

export const onSetDraft = (state: AbsenceMonitoringState) => ({ payload }: Object) => ({
  ...state,
  draft: payload,
});

export const onNewAssignments = (state: AbsenceMonitoringState) => (action: Action<void>) => ({
  ...state,
  assignments: [],
});

export const onSetAssignments = (state: AbsenceMonitoringState) => ({ payload }: Object) => ({
  ...state,
  assignments: payload,
});

export const onSetAbsenceMonitoringDraftAssignments = (state: AbsenceMonitoringState) => ({
  payload,
}: Object) => ({
  ...state,
  draftAssignments: payload,
});

// Config

export const onSetEnabled = (state: AbsenceMonitoringState) => ({ payload }: Object) => ({
  ...state,
  configuration: {
    ...state.configuration,
    enabled: payload,
  },
});

export const onSetStatus = (state: AbsenceMonitoringState) => ({ payload }: Object) => ({
  ...state,
  configuration: {
    ...state.configuration,
    status: payload,
  },
});

// Modals

export const onSetModalStep = (state: AbsenceMonitoringState) => ({ payload }: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    modalStep: payload,
  },
});

export const onSetShowAddModal = (state: AbsenceMonitoringState) => ({ payload }: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    showAddModal: payload,
  },
});

export const onSetShowEditModal = (state: AbsenceMonitoringState) => ({ payload }: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    showEditModal: payload,
  },
});

export const onSetShowEditAssignmentsModal = (state: AbsenceMonitoringState) => ({
  payload,
}: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    showEditAssignmentsModal: payload,
  },
});

export const onSetShowDiscardModal = (state: AbsenceMonitoringState) => ({ payload }: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    showDiscardModal: payload,
  },
});

export const onSetShowSubmitModal = (state: AbsenceMonitoringState) => ({ payload }: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    showSubmitModal: payload,
  },
});

export const onSetShowCancelModal = (state: AbsenceMonitoringState) => ({ payload }: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    showCancelModal: payload,
  },
});

export const onSetShowCancelDiscardModal = (state: AbsenceMonitoringState) => ({
  payload,
}: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    showCancelDiscardModal: payload,
  },
});

export const onSetShowDisableModal = (state: AbsenceMonitoringState) => ({ payload }: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    showDisableModal: payload,
  },
});
